import { isUndNullEmp } from '../../helpers/main.js';

export class SystemAccessDetail {
    constructor(
        _id = 0,
        _systemAccessId = 0,
        _registerDate = '',
        _userRegisterDate = '',
        _informCreationUserId = '',
        _analystId = '',
        _commentary = '',
        _register = '',
    ) {
        this.id = _id;
        this.systemAccessId = _systemAccessId;
        this.registerDate = _registerDate;
        this.userRegisterDate = _userRegisterDate;
        this.informCreationUserId = _informCreationUserId;
        this.analystId = _analystId;
        this.commentary = _commentary;
        this.register = _register;
    }

    static getClassName = () => {
        return 'SystemAccessDetail - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    SystemAccessId: 0,
                    RegisterDate: 10,
                    UserRegisterDate: 10,
                    InformCreationUserId: 10,
                    AnalystId: 10,
                    Commentary: 1,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    SystemAccessId: 450,
                    RegisterDate: 30,
                    UserRegisterDate: 30,
                    InformCreationUserId: 450,
                    AnalystId: 450,
                    Commentary: 1000,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    systemAccessId: 0,
                    registerDate: 10,
                    userRegisterDate: 10,
                    informCreationUserId: 10,
                    analystId: 10,
                    commentary: 1,
                    register: 10,
                },
                max: {
                    id: 450,
                    systemAccessId: 450,
                    registerDate: 30,
                    userRegisterDate: 30,
                    informCreationUserId: 450,
                    analystId: 450,
                    commentary: 1000,
                    register: 30,
                },
            };
        }
    }

    //#region old code
    // static userIdFullPath = ({userId = '', subMethod = ''} = {}) => {
    //     let response = getResponse({ type: 0 });
    //     const currentMethod = 'SystemAccessDetail / userIdFullPath';
    //     try {
    //         if(!isUndNullEmp({data: userId, subMethod: currentMethod})?.result){
    //             userId = userId.replace('~/Images/UserIds/SystemAccessDetail/', `${settings.backend.urls.imageUserIds}${settings.backend.urls.paymentInformations}/`);
    //             response.result = `${settings.backend.urls.api}${userId}`
    //         } else {
    //             response.result = `${settings.backend.urls.api}${settings?.images?.noImage}`;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}<br/>`;
    //     }
    //     return response;
    // }
    //#endregion old code

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: SystemAccessDetail.getClassName() })?.result) {
            if (upperCase) {
                return new SystemAccessDetail(
                    obj.Id,
                    obj.SystemAccessId,
                    obj.RegisterDate,
                    obj.UserRegisterDate,
                    obj.InformCreationUserId,
                    obj.AnalystId,
                    obj.Commentary,
                    obj.Register,
                );
            } else {
                return new SystemAccessDetail(
                    obj.id,
                    obj.systemAccessId,
                    obj.registerDate,
                    obj.userRegisterDate,
                    obj.informCreationUserId,
                    obj.analystId,
                    obj.commentary,
                    obj.register,
                );
            }
        } else {
            return new SystemAccessDetail();
        }
    }
}